export class User {
  constructor(
    public email: string,
  
  ) {}
}
